import { createBrowserHistory } from "history";
import { useEffect } from "react";

import getCoreHistoryStore from "./stores/core/core-history-store";
import getRootStore from "./stores/core/root-store";
import getFirebaseStore from "./stores/firebase-store";

import { ThemeProvider } from "./core/et3-theme";
import getTheme from "./core/et3-theme/getTheme";
import RouterComponent from "./routes";

const App = () => {
  const history = createBrowserHistory();

  useEffect(() => {
    const firebaseStore = getFirebaseStore();

    getCoreHistoryStore().history.set(history);

    getRootStore().startApp();

    // FCM is optional: log and continue if notifications are unavailable.
    firebaseStore
      .requestNotificationPermissionAndRegister()
      .catch((error: unknown) => {
        console.error("FCM token retrieval failed:", error);
      });

    return () => {
      firebaseStore.stopFirebaseMessaging();

      getRootStore().killAppTimersAndListenners();
    };
  }, [history]);

  useEffect(() => {
    if (window.top && window.top !== window.self) {
      window.top.location.href = window.location.href;
    }
  }, []);

  return (
    <ThemeProvider themeValue={getTheme().getThemeData.get()}>
      <RouterComponent />
    </ThemeProvider>
  );
};

export default App;
